import { diagnostics, performanceDiagnostics } from '@/diagnostics/browserDiagnostics';
/** Read within the selection handler so cancellation can still win during parsing. */
export function pickAndReadFile<T>(
  accept: string,
  read: (file: File) => Promise<T>,
): Promise<T | null> {
  return new Promise((resolve, reject) => {
    const input = document.createElement('input');
    input.type = 'file';
    input.accept = accept;
    input.oncancel = () => resolve(null);
    input.onchange = async () => {
      const file = input.files?.[0];
      if (!file) return resolve(null);
      const timing = performanceDiagnostics.start('import-read');
      try {
        resolve(await read(file));
      } catch (error) {
        diagnostics.record('import');
        reject(error);
      } finally {
        performanceDiagnostics.finish('import-read', timing);
      }
    };
    input.click();
  });
}

/** Keep downloads synchronous and release their object URL even if clicking fails. */
export function downloadBlob(blob: Blob, filename: string): void {
  const url = URL.createObjectURL(blob);
  try {
    const link = document.createElement('a');
    link.href = url;
    link.download = filename;
    link.click();
  } finally {
    URL.revokeObjectURL(url);
  }
}
